var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgQuestionMark = function SvgQuestionMark(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 .4C7.4.4.4 7.4.4 16s7 15.6 15.6 15.6 15.6-7 15.6-15.6S24.6.4 16 .4m0 28.2C9.1 28.6 3.4 22.9 3.4 16S9.1 3.4 16 3.4 28.6 9.1 28.6 16 22.9 28.6 16 28.6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16 6.3c-3.3 0-6 2.7-6 6 0 .9.7 1.6 1.6 1.6s1.6-.7 1.6-1.6c0-1.6 1.3-2.8 2.8-2.8 1.6 0 2.8 1.3 2.8 2.8s-1.3 2.8-2.8 2.8c-.9 0-1.6.7-1.6 1.6v2.7c0 .9.7 1.6 1.6 1.6s1.6-.7 1.6-1.6V18c2.6-.7 4.4-3.1 4.4-5.7 0-3.3-2.7-6-6-6m0 16.3c-.9 0-1.6.7-1.6 1.6s.7 1.6 1.6 1.6 1.6-.7 1.6-1.6-.7-1.6-1.6-1.6"
  })));
};
export default SvgQuestionMark;